import Navigation from '../components/Navigation';
import { Outlet } from 'react-router-dom';

export default function RootLayout() {  
  return (
    <div className="flex min-h-screen overflow-hidden">
      <Navigation />
      <main className="flex-grow flex-1 p-8 h-screen overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}